











































































































































import { Component, Emit, Model } from 'vue-property-decorator';
import Vue from 'vue';
import ValueTypes from '@/utils/ValueTypes';
import _ from 'lodash';

@Component
export default class FactorResourceTypeChooser extends Vue {
    @Model('updated:value')
    value: any = null;

    get selected() {
        return _.cloneDeep(this.value);
    }

    set selected(val: any) {
        this.$emit('updated:value', val);
    }

    public FACTOR_OPTIONS = ValueTypes.FACTOR_OPTIONS;

    get factorGroup() {
        return this.FACTOR_OPTIONS[0];
    }

    get otherFactorOptions() {
        return this.FACTOR_OPTIONS.slice(1,this.FACTOR_OPTIONS.length);
    }

    @Emit()
    private submit(valueTypeDefinition: any) {
        return valueTypeDefinition;
    }
}
